const MAX_RETRIES = 3;
const INITIAL_DELAY_MS = 300;
const MAX_DELAY_MS = 2000;

function isRetryable(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const message = error.message;
  return (
    message === "Failed to fetch" ||
    message.includes("NetworkError") ||
    message.includes("ECONNREFUSED") ||
    message.includes("ETIMEDOUT") ||
    message.includes("ENOTFOUND") ||
    message.includes("502") ||
    message.includes("503") ||
    message.includes("504")
  );
}

function getDelay(attempt: number): number {
  const delay = Math.min(INITIAL_DELAY_MS * Math.pow(2, attempt), MAX_DELAY_MS);
  // jitter: +/- 25%
  return delay * (0.75 + Math.random() * 0.5);
}

export async function withRetry<T>(fn: () => Promise<T>): Promise<T> {
  let lastError: unknown;
  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (attempt < MAX_RETRIES && isRetryable(error)) {
        await new Promise(resolve => setTimeout(resolve, getDelay(attempt)));
        continue;
      }
      throw error;
    }
  }
  throw lastError;
}
